const PREFIX = "protopal:wizard:v1:";

type StoredDraft<T> = {
  version: 1;
  savedAt: number;
  value: T;
};

export function loadWizardDraft<T>(name: string): T | null {
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${name}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredDraft<T>;
    if (parsed.version !== 1 || !parsed.value || typeof parsed.value !== "object") return null;
    return parsed.value;
  } catch {
    return null;
  }
}

export function saveWizardDraft<T extends object>(name: string, value: T): void {
  try {
    sessionStorage.setItem(`${PREFIX}${name}`, JSON.stringify({
      version: 1,
      savedAt: Date.now(),
      value,
    } satisfies StoredDraft<T>));
  } catch {
    // Storage can be disabled or full; the wizard remains usable in memory.
  }
}

export function clearWizardDraft(name: string): void {
  try {
    sessionStorage.removeItem(`${PREFIX}${name}`);
  } catch {
    // ignore
  }
}

export function getOrCreateWizardRequestId(name: string): string {
  const key = `${PREFIX}${name}:request`;
  try {
    const current = sessionStorage.getItem(key);
    if (current) return current;
    const next = crypto.randomUUID();
    sessionStorage.setItem(key, next);
    return next;
  } catch {
    return crypto.randomUUID();
  }
}

export function clearWizardRequestId(name: string): void {
  try {
    sessionStorage.removeItem(`${PREFIX}${name}:request`);
  } catch {
    // ignore
  }
}
